
import { serviceQuest } from "./request";
import Swal from 'sweetalert2'
import { endpoints } from "src/configs/config_endpoints";
import "./styles/sweetAlert.css";
import CryptoJS from 'crypto-js';
import { parametros_proyecto, id_proyecto } from "src/configs/config";

// Función para buscar los parametros del proyecto
function buscarPorIdProyecto(id) {
    return parametros_proyecto?.find(objeto => objeto.id === id);
}
const proyecto_encontrado = buscarPorIdProyecto(id_proyecto);

const key = proyecto_encontrado?.key_encript;


// Devuelve el color primario vigente (custom o por proyecto)
function getPrimaryColor() {
    const customColors = JSON.parse(localStorage.getItem('customColors')) || {};
    if (customColors.menu) return customColors.menu;
    if (id_proyecto === '24') return '#1A8036';
    if (id_proyecto === '27') return '#0A395F';
    return '#e23139';
}

function parseHex(hex) {
    const c = hex.replace('#', '');
    return {
        r: parseInt(c.slice(0, 2), 16),
        g: parseInt(c.slice(2, 4), 16),
        b: parseInt(c.slice(4, 6), 16),
    };
}

function lightenHex(hex, factor) {
    const { r, g, b } = parseHex(hex);
    const ch = (v) => Math.min(255, Math.round(v + (255 - v) * factor)).toString(16).padStart(2, '0');
    return `#${ch(r)}${ch(g)}${ch(b)}`;
}

function buildLoadingConfig() {
    const color  = getPrimaryColor();
    const light  = lightenHex(color, 0.45);
    const { r, g, b } = parseHex(color);
    const innerBg  = `rgb(${Math.round(r*0.07)},${Math.round(g*0.07)},${Math.round(b*0.07)})`;
    const backdrop = `rgba(${Math.round(r*0.1)},${Math.round(g*0.1)},${Math.round(b*0.1)},0.96)`;
    const vars = `--ml-c:${color};--ml-cl:${light};--ml-bg:${innerBg};--ml-r:${r};--ml-g:${g};--ml-b:${b}`;
    const html = `
<div class="ml-wrap" style="${vars}">
  <div class="ml-spinner-group">
    <div class="ml-pulse ml-p1"></div>
    <div class="ml-pulse ml-p2"></div>
    <div class="ml-spinner"></div>
  </div>
  <p class="ml-text">Cargando <span class="ml-dot md1">.</span><span class="ml-dot md2">.</span><span class="ml-dot md3">.</span></p>
  <p class="ml-subtext">Esto puede tardar unos segundos&hellip;</p>
</div>`;
    return { html, backdrop };
}

export const requestService = async (props) => {
    // eslint-disable-next-line no-unused-vars
    let timerInterval;
    if (!props.asincrono) {
        const { html, backdrop } = buildLoadingConfig();
        Swal.fire({
            html,
            width: '100%',
            color: '#ffffff',
            background: 'rgba(0, 0, 0, 0)',
            backdrop,
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: {
                container: 'my-swal',
                popup: 'large-sa-popup'
            },
        })
    }
     console.log("props en requestService 2", props);
    const { services } = props;
    let error = false;

    try {
 console.log("dominio",JSON.parse(localStorage.getItem("clientData")));
        console.log("encriptacion0");
        console.log("dominio",JSON.parse(localStorage.getItem("clientData")).dominio + endpoints.urls[services]);
        const responseHttp = await fetch(
            JSON.parse(localStorage.getItem("clientData")).dominio + endpoints.urls[services],
            serviceQuest(props)
        );

        console.log("encriptacion1");

        if (!responseHttp.ok) {
            throw new Error(`Error en la solicitud: ${responseHttp.status}`);
        }

        let encriptacion = localStorage.getItem("encriptacion")
        let requestServ

        console.log("encriptacion", encriptacion);

        if (encriptacion === 'true') {
            // TODO:ESTO SE DEVE APLICAR PARA EL DESENCRIPTAR LOS DATOS
            // Obtener los datos cifrados desde la respuesta
            const encryptedData = await responseHttp.text(); // Obtener como texto
            const decryptedData = decryptData(encryptedData);
            requestServ = JSON.parse(decryptedData);
        } else {
            requestServ = await responseHttp.json();
        }


        // const requestServ = await responseHttp.json();

        if (!error) {
            Swal.close();
        }

        if (responseHttp.status === 403) {
            const requestAuthorizationService = await authorizationServices(responseHttp, requestServ);
            return requestAuthorizationService;
        } else {
            // Decodificar todos los valores de cadena en el objeto requestServ
            const decodedData = decodeObjectValues(requestServ);
            return decodedData;
        }

    } catch (error) {
        Swal.close();
        if (error.message !== "403") {
            window.dispatchEvent(new CustomEvent('siam-server-error', {
                detail: { message: 'Hubo un error en el servidor. Por favor, intentá de nuevo.' }
            }));
        }
    }
}

const authorizationServices = async (responseHttp, responseService) => {
    let response = responseService.wsResponse.replace(/[']/g, '"');
    let wsResponse1 = JSON.parse(response);
    let responseSwal = "";
    await Swal.fire({
        title: 'Ingrese el Codigo de Autenticacion',
        input: 'password',
        inputAttributes: {
            autocapitalize: 'off'
        },
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Confirmar',
        showLoaderOnConfirm: true,
        preConfirm: async (login) => {

            if (login.length > 0) {
                let wsResponse = wsResponse1;
                wsResponse["ws_structure"]["params"]["auth_code"] = login;
                console.log("prueba", wsResponse["ws_structure"]["params"])
                const props = {
                    services: wsResponse["@name"],
                    structure: wsResponse["ws_structure"]["params"]
                }
                return await fetch(responseHttp.url, serviceQuest(props))
                    .then(response => {
                        if (!response.ok) {
                            throw new Error("Codigo de auntentificacion invalido , intente otravez!")
                        }
                        let responseJson = response.json();
                        return responseJson;

                    })
                    .catch(error => {
                        Swal.showValidationMessage(
                            `${error}`
                        )
                    })
            } else {
                Swal.showValidationMessage(
                    'Es necesario ingresar al menos un caracter.'
                )
            }

        },
        allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
        if (result.isConfirmed) {
            responseSwal = result.value
            return result.value;
        }
    })
    if (responseSwal === "") {
        responseSwal = { cancel: true }
    }
    return responseSwal;
};

// TODO:ESTO SE DEVE APLICAR PARA EL DESENCRIPTAR LOS DATOS RECIVIDOS
// eslint-disable-next-line
const decryptData = (encodedData) => {

    const [encodedIV, encodedEncryptedData] = encodedData.split(':');

    // Decodificar IV y datos cifrados desde base64
    const iv = CryptoJS.enc.Base64.parse(encodedIV);
    const ciphertext = CryptoJS.enc.Base64.parse(encodedEncryptedData);

    // Clave en formato hexadecimal
    const key_codificada = CryptoJS.enc.Hex.parse(key);

    try {
        // Descifrar utilizando AES-256-CBC y Pkcs7 padding
        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: ciphertext },
            key_codificada,
            { iv: iv, padding: CryptoJS.pad.Pkcs7 }
        );

        // Convertir a texto UTF-8
        const plaintext = decrypted.toString(CryptoJS.enc.Utf8);

        return plaintext;
    } catch (error) {
        console.error('Error al descifrar los datos:', error);
        return null;
    }
};

function htmlDecode(str) {
    if (typeof str !== "string") return str;

    try {
        // Primero decodificamos cosas tipo %26gt;
        const urlDecoded = decodeURIComponent(str);

        // Después entidades HTML (&gt;, &lt;, &amp;, etc.)
        const textarea = document.createElement("textarea");
        textarea.innerHTML = urlDecoded;
        return textarea.value;
    } catch (e) {
        return str; // si falla decodeURIComponent, devolvemos original
    }
}
function decodeObjectValues(obj) {
    if (typeof obj === "string") {
        return htmlDecode(obj);
    }

    if (Array.isArray(obj)) {
        return obj.map((item) => decodeObjectValues(item));
    }

    if (obj !== null && typeof obj === "object") {
        const newObj = {};
        for (const key in obj) {
            newObj[key] = decodeObjectValues(obj[key]);
        }
        return newObj;
    }

    return obj; // number, boolean, null, undefined
}


